import { StandaloneComponent } from '@/types/component';
import LabradorArticleTeaserBodytext, {
  StandaloneArticleTeaserBodytext,
  StandaloneArticleTeaserBodytextProps,
} from 'base/components/content/ArticleTeaser/Bodytext';
import mergeProps from 'lib/utils/mergeProps';

const AllasStandaloneArticleTeaserBodytext: StandaloneComponent<StandaloneArticleTeaserBodytextProps> = (props) => (
  <StandaloneArticleTeaserBodytext
    {...mergeProps(
      {
        options: {
          variant: 'fourth',
          $image: {
            variant: 'fourth',
          },
        },
      },
      props
    )}
  />
);

export const standalone = AllasStandaloneArticleTeaserBodytext;

export default LabradorArticleTeaserBodytext;
